const startUpBundleProducts = [
  {
    name: 'Zempler business bank account',
    logo: 'https://img.money.co.uk/s3/uswitch-assets-eu/amp/images/provider/logos/Zempler_formerly_cashplus.png',
  },
  {
    name: 'Funding Options start-up loans',
    logo: 'https://img.money.co.uk/s3/uswitch-assets-eu/amp/images/provider/logos/Funding_option_by_tyde.jpg',
  },
  {
    name: 'Superscript business insurance',
    logo: 'https://img.uswitch.com/t014ej9w3ur1/6wpljlv8XQOIwb5jt4zLnJ/c477084c7504f000fc768b81e11bd7bc/Superscript_Logo_Full_2x.png',
  },
  {
    name: 'Tuza card payment solutions',
    logo: 'https://img.money.co.uk/s3/uswitch-assets-eu/amp/images/provider/logos/Tuza1x.jpg',
  },
]

export const startUpBundle = {
  title: 'Starting your business',
  description:
    'We’ve partnered with some of the best providers to bring you products specifically chosen for startups and new businesses.',
  tooltipTitle:
    'We’ve partnered with some of the best providers to provide you with the tools you need to get your business started.',
  toolTipContent:
    'Our start up bundle includes new business essentials: business bank accounts, card payment solutions and start-up loans help with cash flow and receiving payments while business insurance protects your business from a range of unforeseen events.',
  products: startUpBundleProducts,
  link: '/business/journey?businessBundle=startup',
}

const midProducts = [
  {
    name: 'Tide business bank account',
    logo: 'https://img.money.co.uk/s3/uswitch-assets-eu/amp/images/provider/logos/tide_2021.png',
  },
  {
    name: 'Funding Options business loans',
    logo: 'https://img.money.co.uk/s3/uswitch-assets-eu/amp/images/provider/logos/Funding_option_by_tyde.jpg',
  },
  {
    name: 'Superscript business insurance',
    logo: 'https://img.uswitch.com/t014ej9w3ur1/6wpljlv8XQOIwb5jt4zLnJ/c477084c7504f000fc768b81e11bd7bc/Superscript_Logo_Full_2x.png',
  },
  {
    name: 'Barclaycard Business Credit Card',
    logo: 'https://img.money.co.uk/s3/uswitch-assets-eu/amp/images/product/credit-cards/Select_Cashback_credit_card_horizontal_may.jpg',
  },
]

export const midBundle = {
  title: 'Scaling your business',
  description:
    'We’ve partnered with some of the best providers to bring you products specifically chosen for businesses looking to scale up.',
  tooltipTitle:
    'We’ve partnered with some of the best providers to bring you products specifically chosen for businesses looking to scale up.',
  toolTipContent:
    'Our scale up bundle will provide you with the tools to grow your business, whether you’re looking for a new business bank account or loan to manage your business’s finances or you’re looking for tailored insurance to cover your business against unforeseen events - we’ve got you covered.',
  products: midProducts,
  link: '/business/journey?businessBundle=mid',
}

const largeProducts = [
  {
    name: 'Tuza card payment solutions',
    logo: 'https://img.money.co.uk/s3/uswitch-assets-eu/amp/images/provider/logos/Tuza1x.jpg',
  },
  {
    name: 'Tide business saving account',
    logo: 'https://img.money.co.uk/s3/uswitch-assets-eu/amp/images/provider/logos/tide_2021.png',
  },
  {
    name: 'Tide business bank account',
    logo: 'https://img.money.co.uk/s3/uswitch-assets-eu/amp/images/provider/logos/tide_2021.png',
  },
  {
    name: 'Funding Options business loans',
    logo: 'https://img.money.co.uk/s3/uswitch-assets-eu/amp/images/provider/logos/Funding_option_by_tyde.jpg',
  },
]

export const largeBundle = {
  title: 'Establishing your business',
  description:
    'We’ve partnered with some of the best providers to bring you products specifically chosen for your established business.',
  tooltipTitle:
    'We’ve partnered with some of the best providers to bring you products specifically chosen for your established business.',
  toolTipContent:
    'We’ve partnered with some of the best providers to bring you products specifically chosen for your established business. This bundle will provide you with the tools you need to manage things effectively and efficiently, from business saving accounts helping you make money on your money to invoice finance, providing you with more reliable cash flow.',
  products: largeProducts,
  link: '/business/journey?businessBundle=large',
}
